import RouteEnum from './RouteEnum'

const StepOrder = {
  CompanyStep: 1,
  LegalResponsibleStep: 2,
  AddressStep: 3,
  SecurityStep: 4,
  SuccessStep: 5,
}

const OrderRoutes = {
  [StepOrder.CompanyStep]: RouteEnum.CompanyStep,
  [StepOrder.LegalResponsibleStep]: RouteEnum.LegalResponsibleStep,
  [StepOrder.AddressStep]: RouteEnum.AddressStep,
  [StepOrder.SecurityStep]: RouteEnum.SecurityStep,
  [StepOrder.SuccessStep]: RouteEnum.SuccessStep,
}

export { StepOrder, OrderRoutes }
